import ButtonWithPlus from '@shared/ui/button-with-plus';
import * as stylex from '@stylexjs/stylex';
import { useState, useEffect, useRef } from 'react';
import { FieldOption } from '@entities/leadCollector';
import { styles } from './styles';

interface AddFieldButtonProps {
  options: FieldOption[];
  onSelect: (option: FieldOption) => void;
  buttonText?: string;
}

export const AddFieldButton = ({ options, onSelect, buttonText = 'Добавить поле' }: AddFieldButtonProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  const handleButtonClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionSelect = (option: FieldOption) => {
    if (option.disabled) return;
    onSelect(option);
    setIsDropdownOpen(false);
  };

  return (
    <div {...stylex.props(styles.buttonWrapper)} ref={dropdownRef}>
      <ButtonWithPlus handleClick={handleButtonClick} labelText={buttonText} />
      {isDropdownOpen && (
        <ul {...stylex.props(styles.dropdown)}>
          {options.map((option) => (
            <li
              key={option.dbField}
              {...stylex.props(styles.dropdownItem, option.disabled && styles.dropdownItemDisabled)}
            >
              <button
                onClick={() => handleOptionSelect(option)}
                disabled={option.disabled}
                {...stylex.props(styles.dropdownButton)}
                role="menuitem"
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
